import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { WidgetsOutlined, ArrowBackIos } from '@material-ui/icons';
import ReportRequestService from 'services/report-request';

export default function (){
  const history = useHistory();
  const location = useLocation();
  const [reportsList, setReportsList] = useState([]);

  useEffect(()=>{
    ReportRequestService.getList().then(({data})=>{
      setReportsList(data);
    });
  },[]);

  return (
    <>
      <Container className="mb-5">
        <Row className="mt-2">
          <Button variant="link" className="link-back" onClick={() => history.goBack()}>
            <ArrowBackIos className="icon-title icon-back" />
            <h6 className="font-13 mt-3">Voltar</h6>
          </Button>
        </Row>
        <Row className="mt-2">
          <WidgetsOutlined className="icon-title" />
          <h5 className="title-dashboard">Relatórios</h5>
        </Row>
        <Row style={{position: 'relative'}}>
          {reportsList.map((report, k) => {
            return (
              <Col xs="4" sm="4" md="4" lg="4" xl="3" style={{ minHeight: '175px' }} className='mt-4' key={k}>
                <Card className="h-100 bg-white font-weight-bold d-flex justify-content-center align-items-center shadow rounded text-center h-100">
                  <Card.Body>
                    <Link className="text-primary" to={location.pathname+"/"+report.link}>
                      <p style={{fontSize:"large"}}>{report.name}</p>
                      <p style={{
                        fontWeight: "200",
                        fontSize: "small",
                        margin: "0px"
                      }}>{report.description}</p>
                    </Link>
                  </Card.Body>
                </Card>
              </Col>              
            );
          })}
        </Row>
      </Container>
    </>
  );
};
